/* apps/viewer/src/app/toc-items/note-module/note-list/note-list.component.scss */
:host {
  align-self: center;
  max-width: 900px;
  width: 100%;
}
:host .mat-mdc-table {
  margin-top: 10px;
}
:host .select-unselect-actions {
  display: flex;
  flex-direction: row;
  font-size: 14px;
  justify-content: space-between;
  max-width: 900px;
  padding: 0 24px 10px;
  z-index: 2;
}
:host .select-unselect-actions a {
  border-radius: 3px;
  cursor: pointer;
  margin: auto 10px;
  text-decoration: underline;
}
:host ::ng-deep .mat-mdc-table {
  background: inherit !important;
}
:host ::ng-deep mat-table > .mat-mdc-cell {
  overflow: auto;
}
:host ::ng-deep mat-header-row {
  display: none;
}
:host ::ng-deep mat-row {
  border: none;
}
:host ::ng-deep mat-cell {
  border-bottom: none;
  overflow: unset;
}
:host ::ng-deep o-note {
  width: 100%;
}
.button-container {
  display: flex;
  flex-direction: row;
}
button.mat-mdc-menu-item {
  align-items: center;
  display: flex;
}
button.mat-mdc-menu-item input {
  display: none;
}
.note__header {
  display: flex;
}
.media-storage-info {
  align-self: center;
  font-size: 12px;
  margin-right: 10px;
}
@media screen and (max-width: 575px) {
  .button-container {
    align-self: flex-end;
  }
  .media-storage-info {
    text-align: end;
  }
  .note__header {
    flex-direction: column-reverse;
  }
}
@media print {
  mat-row {
    display: block;
    min-height: 0;
  }
  mat-cell {
    display: block;
  }
  mat-checkbox {
    display: none;
  }
  ::ng-deep o-note {
    page-break-inside: avoid;
  }
}
/*# sourceMappingURL=note-list.component.css.map */
